(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  _exports.__esModule = true;
  _exports.WX_MENU_SOCIAL = _exports.ShareChannels = void 0;
  var WX_MENU_SOCIAL = ["menuItem:share:appMessage", "menuItem:share:timeline", "menuItem:share:qq", // "menuItem:share:weiboApp",
  // "menuItem:share:facebook",
  "menuItem:share:QZone"];
  _exports.WX_MENU_SOCIAL = WX_MENU_SOCIAL;
  var ShareChannels = [{
    name: "Timeline",
    method: "updateTimelineShareData"
  }, {
    name: "AppMessage",
    method: "updateAppMessageShareData"
  }, {
    name: "AppMessage",
    method: "onMenuShareWechat"
  }, // to be deprecated. but maybe required in wechat work.
  {
    name: "Timeline",
    method: "onMenuShareTimeline"
  }, {
    name: "AppMessage",
    method: "onMenuShareAppMessage"
  }];
  _exports.ShareChannels = ShareChannels;
});
//# sourceMappingURL=index.js.map